<template>
  <div>
    <iModal
      title="新增关联类别"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="关联类别：" prop="type" :required="true">
              <!-- <categoryFiledType
                v-model="formInline.type"
                ref="categoryFiledType"
                v-if="formInline.type && showModal"
              ></categoryFiledType> -->
              <Select v-model="formInline.type" multiple @on-change="selectChange">
                <Option v-for="item in type" :value="item.name" :key="item.name">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template> 

<script>
import { mapActions } from "vuex";
import categoryFiledType from "@components/category-filed-typeNew/category-filed-type.vue";

export default {
  name: "classify-contact-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editInfo: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      formInline: {
        type: [], // 关联类别
        typeInfo: []
      },
      ruleInline: {
        type: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("关联类别为必填选项");
              } else if (value.length) {
                callback();
              } else {
                callback("关联类别为必填选项");
              }
            },
            trigger: "blur"
          }
        ]
      },
      type: []
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  components: {
    categoryFiledType
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    editInfo(val, oldVal) {
      this.init();
      // if (this.$refs["categoryFiledType"]) {
      //   this.$refs["categoryFiledType"].init();
      // }
    }
  },
  created() {},
  methods: {
    ...mapActions({
      putWebKindCategory: "webKindModule/putWebKindCategory",
      getCategoryByExhibitionList:
        "exhibitionModule/getCategoryByExhibitionList"
    }),
    async init() {
      let categoryData = await this.getCategoryByExhibitionList(
        this.exhibitionInfo.id
      );
      if (categoryData && categoryData.length) {
        this.type = categoryData;
      } else {
        this.type = [];
      }
      if (this.editInfo) {
        this.formInline.type = [];
        this.formInline.typeInfo = [];
        let categories = JSON.parse(JSON.stringify(this.editInfo.categoryList));
        if (categories.length) {
          // if (
          //   Object.prototype.toString.call(categories[0]) === "[object Object]"
          // ) {
          //   this.formInline.type = categories;
          // }
          let arr = [];
          this.type.forEach(c => {
            let value = null;
            categories.forEach(d => {
              if (c.name === d.Name) {
                this.formInline.type.push(c.name);
                value = JSON.parse(JSON.stringify(c));
                value.list = [];
                arr.push(value);
              }
            })
          });
          this.formInline.typeInfo = arr;
        }
      }
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Id: this.editInfo.id,
        List: form.typeInfo
      };
      // console.log(req);
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.putWebKindCategory(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.formInline.type = [];
      this.formInline.typeInfo = [];
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      // this.$refs["categoryFiledType"].close();
      
      this.loading = false;
      this.showModal = false;
    },
    selectChange(e) {
      let arr = [];
      if (this.type && this.type.length) {
        this.type.forEach(c => {
          let value = null;
          e.forEach(d => {
            if (c.name === d) {
              value = JSON.parse(JSON.stringify(c));
              value.list = [];
            }
          })
          if (value) {
            arr.push(value);
          }
        });
      }
      this.formInline.typeInfo = arr;
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

